// @ts-strict

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, Subject } from 'rxjs';
import { BaseApiResponse, IBannerConfigurationsData, PageableApiResponse, IBannerConfigurationData, DefaultApiMessageResponse } from '../../models/core-models';
import { IBannerData, IBannerSizeData } from './banners.service.types';

@Injectable({
  providedIn: 'root'
})
export class BannersService {
  public newBanner: Subject<IBannerConfigurationData> = new Subject();

  constructor(private readonly http: HttpClient) {}

  public getBannersList(programId: number, page: number = 1, resolution: string): Observable<PageableApiResponse<{ banners?: IBannerData[] }>> {
    const params = { page: page, resolution: resolution };

    return this.http.get<PageableApiResponse<{ banners?: IBannerData[] }>>(environment.apiUrl + `/campaigns/${programId}/banners/list`, {
      params
    });
  }

  public getUserCreatedBanners(programId: number): Observable<BaseApiResponse<IBannerConfigurationsData>> {
    return this.http.get<BaseApiResponse<IBannerConfigurationsData>>(environment.apiUrl + `/campaigns/${programId}/banners/created`);
  }

  public addBannerConfiguration(
    config_id: number,
    banner_id: number,
    domain_id: number,
    programId: number
  ): Observable<BaseApiResponse<Pick<IBannerConfigurationData, 'banner_id' | 'configuration_id'>>> {
    const bannerConfiguration = {
      config_id,
      banner_id,
      domain_id
    };

    return this.http.post<BaseApiResponse<IBannerConfigurationData>>(environment.apiUrl + `/campaigns/${programId}/banners/create`, bannerConfiguration);
  }

  public getBannersSizes(programId: number): Observable<PageableApiResponse<{ banner_sizes?: IBannerSizeData[] }>> {
    return this.http.get<PageableApiResponse<{ banner_sizes?: IBannerSizeData[] }>>(environment.apiUrl + `/campaigns/${programId}/banners/sizes`);
  }

  public getBannerScript(banner_config_id: number, domain_id: number, programId: number): Observable<BaseApiResponse<{ script?: string }>> {
    const bannerConfiguration = {
      banner_config_id,
      domain_id
    };

    return this.http.post<BaseApiResponse<{ script?: string }>>(environment.apiUrl + `/campaigns/${programId}/banners/script`, bannerConfiguration);
  }

  public removeBanner(programID: number, configID: number): Observable<DefaultApiMessageResponse> {
    return this.http.delete<DefaultApiMessageResponse>(environment.apiUrl + `/campaigns/${programID}/banners/${configID}/delete`);
  }
}
